// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BasicInformation_basic-information__4BWPZ {
  width: 22%;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 {
  width: 100%;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_personal-information__GgqO8 {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  background: var(--explore-color);
  width: 100%;
  border-radius: 10px;
  color: white;
  padding: 15px;
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_personal-information__GgqO8 .BasicInformation_personal-information-main__mwn8R {
  display: flex;
  align-items: flex-start;
  width: 100%;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_personal-information__GgqO8 .BasicInformation_faculty-collaboration-btn__S6dh3 {
  margin-top: 12px;
  width: 100%;
  justify-content: center;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_personal-information__GgqO8 .BasicInformation_avatar__kVAo6 {
  flex-shrink: 0;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_personal-information__GgqO8 img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 50%;
  background-color: white;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_personal-information__GgqO8 .BasicInformation_personal-information-text__iqqrJ {
  margin-left: 15px;
  display: flex;
  flex-direction: column;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_personal-information__GgqO8 .BasicInformation_personal-information-text__iqqrJ .BasicInformation_name__59D9k {
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 5px 0;
  line-height: 1.2;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_personal-information__GgqO8 .BasicInformation_personal-information-text__iqqrJ .BasicInformation_loading-text__UmCT\\+ {
  font-size: 14px;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_institution__Fb6kj {
  display: flex;
  gap: 10px;
  width: 100%;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 15px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_institution__Fb6kj img {
  width: 25px;
  height: 25px;
  margin-right: 10px;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_institution__Fb6kj p:hover {
  color: var(--blue);
  text-decoration: underline;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_unit__WNkQd {
  display: flex;
  gap: 10px;
  width: 100%;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 15px;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_unit__body__w1iEc {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_unit--title__CkBfz {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_unit__content__eTDSA {
  display: flex;
  gap: 10px;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_unit__content--info__p4vTk {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_unit__content--info--item__kciKL {
  padding-bottom: 5px;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_unit__content--info--item__kciKL:not(:last-child) {
  border-bottom: 1px solid var(--light-grey);
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_unit__content--info--item--name__SFLxV {
  font-size: 14px;
  font-weight: 600;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_unit__content--info--item--sub-name__Ab1zz {
  font-size: 14px;
  margin-bottom: 5px !important;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_unit__content--info--item__kciKL .BasicInformation_link__nUX7X:hover, .BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_unit__content--info--item__kciKL .BasicInformation_link__nUX7X:hover > * {
  color: var(--blue) !important;
  text-decoration: underline;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_basic-informations__hKl-u {
  width: 100%;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_basic-informations__hKl-u p {
  line-height: 20px !important;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_basic-informations__hKl-u .BasicInformation_loading-text__UmCT\\+ {
  margin-bottom: 5px;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_basic-informations__hKl-u .BasicInformation_work-history__A9TiR {
  width: 100%;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_basic-informations__hKl-u .BasicInformation_work-history__A9TiR .BasicInformation_work-info__dh2n- {
  margin: 10px 0 15px 0;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_basic-informations__hKl-u .BasicInformation_work-history__A9TiR .BasicInformation_other-profiles__BRq1Y {
  margin: 10px 0 15px 0;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_basic-informations__hKl-u .BasicInformation_work-history__A9TiR .BasicInformation_other-profiles__BRq1Y .BasicInformation_title-section__ITqFL {
  font-weight: bold;
  margin-bottom: 20px !important;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_basic-informations__hKl-u .BasicInformation_work-history__A9TiR .BasicInformation_other-profiles__BRq1Y .BasicInformation_profiles__-27OP {
  display: flex;
  flex-direction: column;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_basic-informations__hKl-u .BasicInformation_work-history__A9TiR .BasicInformation_line-profile__BifXF {
  display: flex;
  align-items: flex-start;
  font-size: 12px;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_basic-informations__hKl-u .BasicInformation_work-history__A9TiR .BasicInformation_line-profile__BifXF:not(:last-child) {
  border-bottom: 1px solid var(--light-grey);
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_basic-informations__hKl-u .BasicInformation_work-history__A9TiR .BasicInformation_line-profile__BifXF .ant-skeleton {
  width: 120px;
  height: 30px;
  margin-bottom: 5px;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_basic-informations__hKl-u .BasicInformation_work-history__A9TiR .BasicInformation_line-profile__BifXF .ant-skeleton .ant-skeleton-input {
  width: 100%;
  height: 30px;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_basic-informations__hKl-u .BasicInformation_work-history__A9TiR .BasicInformation_line-profile__BifXF img {
  width: 25px;
  height: 25px;
  margin-right: 10px;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_basic-informations__hKl-u .BasicInformation_work-history__A9TiR .BasicInformation_line-profile__BifXF svg {
  width: 25px;
  height: 25px;
  margin-right: 10px;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_basic-informations__hKl-u .BasicInformation_work-history__A9TiR .BasicInformation_description__F\\+xF2 p {
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 .BasicInformation_basic-informations__hKl-u .BasicInformation_work-history__A9TiR .BasicInformation_see-more__WRyat {
  color: var(--blue);
  text-decoration: underline;
  cursor: pointer;
}
.BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-mobile__ML6OY {
  display: none;
}
@media only screen and (min-width: 901px) and (max-width: 1024px) {
  .BasicInformation_basic-information__4BWPZ {
    width: 27%;
  }
}
@media only screen and (max-width: 900px) {
  .BasicInformation_basic-information__4BWPZ {
    width: 97%;
    flex-direction: row;
  }
  .BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-landscape__tWdk9 {
    display: none;
  }
  .BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-mobile__ML6OY {
    width: 100%;
    display: flex !important;
    flex-direction: column;
  }
  .BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-mobile__ML6OY .BasicInformation_informations__rKyyo {
    overflow-x: hidden;
    width: 100%;
    background-color: var(--explore-color);
    border-radius: 10px;
    padding: 20px 10px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 5px;
  }
  .BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-mobile__ML6OY .BasicInformation_informations__rKyyo .ant-skeleton {
    width: 55vw;
    margin-bottom: 5px;
    height: 20px;
  }
  .BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-mobile__ML6OY .BasicInformation_informations__rKyyo .ant-skeleton .ant-skeleton-input {
    width: 100%;
    height: 20px;
  }
  .BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-mobile__ML6OY .BasicInformation_informations__left__NeAxX {
    width: 33%;
  }
  .BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-mobile__ML6OY .BasicInformation_informations__left__NeAxX .BasicInformation_avatar__kVAo6 {
    flex-shrink: 0;
  }
  .BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-mobile__ML6OY .BasicInformation_informations__left__NeAxX .BasicInformation_avatar__kVAo6 .ant-skeleton {
    width: 100px;
    height: 100px;
  }
  .BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-mobile__ML6OY .BasicInformation_informations__left__NeAxX .BasicInformation_avatar__kVAo6 .ant-skeleton .ant-skeleton-avatar {
    width: 100px;
    height: 100px;
  }
  .BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-mobile__ML6OY .BasicInformation_informations__left__NeAxX .BasicInformation_avatar__kVAo6 {
    margin-right: 15px;
  }
  .BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-mobile__ML6OY .BasicInformation_informations__left__NeAxX .BasicInformation_avatar__kVAo6 img {
    width: 100px;
    height: 100px;
    object-fit: cover;
    border-radius: 50%;
  }
  .BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-mobile__ML6OY .BasicInformation_informations__left__NeAxX .BasicInformation_external-links__s4Fq\\+ {
    width: 100px;
    display: flex;
    justify-content: center;
  }
  .BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-mobile__ML6OY .BasicInformation_informations__right__Mc-U0 {
    width: 65%;
  }
  .BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-mobile__ML6OY .BasicInformation_informations__right__Mc-U0 .BasicInformation_name__59D9k {
    font-size: 20px;
    font-weight: 600;
    color: white;
    margin: 0 0 5px 0 !important;
    line-height: 1.2;
  }
  .BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-mobile__ML6OY .BasicInformation_informations__right__Mc-U0 .BasicInformation_primary-department__mpRGc {
    color: white;
    font-size: 14px;
    font-weight: 600;
  }
  .BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-mobile__ML6OY .BasicInformation_informations__right__Mc-U0 .BasicInformation_position__2GTNQ {
    color: white;
    font-size: 14px;
  }
  .BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-mobile__ML6OY .BasicInformation_informations__rKyyo .BasicInformation_second-section__xuuBG {
    display: flex;
    align-items: center;
    width: 280px;
    justify-content: space-around;
  }
  .BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-mobile__ML6OY .BasicInformation_informations__rKyyo .BasicInformation_second-section__xuuBG .BasicInformation_read-bio__I-ARw {
    border: 1px solid var(--explore-color);
    border-radius: 10px;
    height: 30px;
    width: 90px;
    background: transparent;
    color: var(--explore-color);
  }
  .BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-mobile__ML6OY .BasicInformation_informations__rKyyo .BasicInformation_second-section__xuuBG .BasicInformation_read-bio__I-ARw:hover {
    background: var(--explore-color);
    color: white;
  }
  .BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-mobile__ML6OY .BasicInformation_informations__rKyyo .BasicInformation_third-section__OFl6Q {
    margin-top: 20px;
  }
  .BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-mobile__ML6OY .BasicInformation_informations__rKyyo .BasicInformation_third-section__OFl6Q .BasicInformation_citation-title__x6qDb {
    font-weight: 600;
  }
  .BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-mobile__ML6OY .BasicInformation_informations__rKyyo .BasicInformation_third-section__OFl6Q .ant-skeleton {
    width: 100%;
    height: 200px;
    margin-top: 10px;
  }
  .BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-mobile__ML6OY .BasicInformation_informations__rKyyo .BasicInformation_third-section__OFl6Q .ant-skeleton .ant-skeleton-input {
    width: 100%;
    height: 200px;
  }
  .BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-mobile__ML6OY .BasicInformation_mobile-collaboration-btn__VNIYg {
    margin-top: 10px;
    margin-bottom: 5px;
    width: 100%;
    justify-content: center;
  }
  .BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-mobile__ML6OY .BasicInformation_bio-info__2lCqY {
    font-size: 12px;
    margin-top: 16px;
    padding: 16px 24px 16px 16px;
    gap: 8px;
    justify-content: initial;
    text-transform: initial;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    text-align: initial;
    line-height: normal;
    font-weight: 400;
    color: var(--explore-color);
  }
  .BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-mobile__ML6OY .BasicInformation_bio-info__2lCqY svg {
    fill: currentColor;
    width: 14px;
    height: 14px;
  }
  .BasicInformation_basic-information__4BWPZ .BasicInformation_basic-information-mobile__ML6OY .BasicInformation_achievements__0gNFm {
    display: flex;
    margin-top: 10px;
  }
  .BasicInformation_basic-information__4BWPZ .ant-drawer-body p {
    line-height: 24px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/FacultyDetail/Components/BasicInformation/BasicInformation.module.scss"],"names":[],"mappings":"AAUA;EACE,UAAA;AATF;AAWE;EACE,WAAA;AATJ;AAWI;EACE,yCAAA;EACA,gCAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AATN;AAWM;EACE,aAAA;EACA,uBAAA;EACA,WAAA;AATR;AAYM;EACE,gBAAA;EACA,WAAA;EACA,uBAAA;AAVR;AAaM;EACE,cAAA;AAXR;AAcM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;AAZR;AAeM;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;AAbR;AAeQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAbV;AAgBQ;EACE,eAAA;AAdV;AAmBI;EApEF,aAAA;EACA,SAAA;EACA,WAAA;EACA,yCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EAgEI,eAAA;EACA,iBAAA;EACA,gBAAA;AAXN;AAaM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAXR;AAeQ;EACE,kBAAA;EACA,0BAAA;AAbV;AAkBI;EAxFF,aAAA;EACA,SAAA;EACA,WAAA;EACA,yCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAyEF;AAYM;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAVR;AAaM;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AAXR;AAcM;EACE,aAAA;EACA,SAAA;AAZR;AAcQ;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAZV;AAcU;EACE,mBAAA;AAZZ;AAcY;EACE,0CAAA;AAZd;AAeY;EACE,eAAA;EACA,gBAAA;AAbd;AAgBY;EACE,eAAA;EACA,6BAAA;AAdd;AAkBc;EAEE,6BAAA;EACA,0BAAA;AAjBhB;AAyBI;EACE,WAAA;EACA,yCAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;AAvBN;AAyBM;EACE,4BAAA;AAvBR;AA0BM;EACE,kBAAA;AAxBR;AA2BM;EACE,WAAA;AAzBR;AA2BQ;EACE,qBAAA;AAzBV;AA4BQ;EACE,qBAAA;AA1BV;AA4BU;EACE,iBAAA;EACA,8BAAA;AA1BZ;AA6BU;EACE,aAAA;EACA,sBAAA;AA3BZ;AA+BQ;EACE,aAAA;EACA,uBAAA;EACA,eAAA;AA7BV;AA+BU;EACE,0CAAA;AA7BZ;AAgCU;EACE,YAAA;EACA,YAAA;EACA,kBAAA;AA9BZ;AAgCY;EACE,WAAA;EACA,YAAA;AA9Bd;AAkCU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAhCZ;AAmCU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAjCZ;AAsCU;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AApCZ;AAwCQ;EACE,kBAAA;EACA,0BAAA;EACA,eAAA;AAtCV;AA4CE;EACE,aAAA;AA1CJ;AA6CE;EAnOF;IAoOI,UAAA;EA1CF;AACF;AA4CE;EAvOF;IAwOI,UAAA;IACA,mBAAA;EAzCF;EA2CE;IACE,aAAA;EAzCJ;EA4CE;IACE,WAAA;IACA,wBAAA;IACA,sBAAA;EA1CJ;EA4CI;IACE,kBAAA;IACA,WAAA;IACA,sCAAA;IACA,mBAAA;IACA,kBAAA;IACA,aAAA;IACA,uBAAA;IACA,8BAAA;IACA,kBAAA;EA1CN;EA4CM;IACE,WAAA;IACA,kBAAA;IACA,YAAA;EA1CR;EA4CQ;IACE,WAAA;IACA,YAAA;EA1CV;EA8CM;IACE,UAAA;EA5CR;EA6CQ;IACE,cAAA;EA3CV;EA4CU;IACE,YAAA;IACA,aAAA;EA1CZ;EA4CY;IACE,YAAA;IACA,aAAA;EA1Cd;EAkCQ;IAYE,kBAAA;EA3CV;EA6CU;IACE,YAAA;IACA,aAAA;IACA,iBAAA;IACA,kBAAA;EA3CZ;EA+CQ;IACE,YAAA;IACA,aAAA;IACA,uBAAA;EA7CV;EAiDM;IACE,UAAA;EA/CR;EAiDQ;IACE,eAAA;IACA,gBAAA;IACA,YAAA;IACA,4BAAA;IACA,gBAAA;EA/CV;EAkDQ;IACE,YAAA;IAEA,eAAA;IACA,gBAAA;EAjDV;EAoDQ;IACE,YAAA;IACA,eAAA;EAlDV;EAsDM;IACE,aAAA;IACA,mBAAA;IACA,YAAA;IACA,6BAAA;EApDR;EAsDQ;IACE,sCAAA;IACA,mBAAA;IACA,YAAA;IACA,WAAA;IACA,uBAAA;IACA,2BAAA;EApDV;EAuDQ;IACE,gCAAA;IACA,YAAA;EArDV;EAyDM;IACE,gBAAA;EAvDR;EAyDQ;IACE,gBAAA;EAvDV;EA0DQ;IACE,WAAA;IACA,aAAA;IACA,gBAAA;EAxDV;EA0DU;IACE,WAAA;IACA,aAAA;EAxDZ;EA8DI;IACE,gBAAA;IACA,kBAAA;IACA,WAAA;IACA,uBAAA;EA5DN;EA+DI;IACE,eAAA;IACA,gBAAA;IACA,4BAAA;IACA,QAAA;IACA,wBAAA;IACA,uBAAA;IACA,yCAAA;IACA,mBAAA;IACA,mBAAA;IACA,mBAAA;IACA,gBAAA;IACA,2BAAA;EA7DN;EA+DM;IACE,kBAAA;IACA,WAAA;IACA,YAAA;EA7DR;EAiEI;IACE,aAAA;IACA,gBAAA;EA/DN;EAwEI;IACE,4BAAA;EAnEN;AALF","sourcesContent":["@mixin default-box {\n  display: flex;\n  gap: 10px;\n  width: 100%;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  padding: 20px;\n  margin-bottom: 15px;\n}\n\n.basic-information {\n  width: 22%;\n\n  .basic-information-landscape {\n    width: 100%;\n\n    .personal-information {\n      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n      background: var(--explore-color);\n      width: 100%;\n      border-radius: 10px;\n      color: white;\n      padding: 15px;\n      display: flex;\n      flex-direction: column;\n      margin-bottom: 15px;\n\n      .personal-information-main {\n        display: flex;\n        align-items: flex-start;\n        width: 100%;\n      }\n\n      .faculty-collaboration-btn {\n        margin-top: 12px;\n        width: 100%;\n        justify-content: center;\n      }\n\n      .avatar {\n        flex-shrink: 0;\n      }\n\n      img {\n        width: 80px;\n        height: 80px;\n        object-fit: cover;\n        border-radius: 50%;\n        background-color: white;\n      }\n\n      .personal-information-text {\n        margin-left: 15px;\n        display: flex;\n        flex-direction: column;\n\n        .name {\n          font-size: 20px;\n          font-weight: 600;\n          margin: 0 0 5px 0;\n          line-height: 1.2;\n        }\n\n        .loading-text {\n          font-size: 14px;\n        }\n      }\n    }\n\n    .institution {\n      @include default-box;\n      font-size: 16px;\n      line-height: 24px;\n      font-weight: 600;\n\n      img {\n        width: 25px;\n        height: 25px;\n        margin-right: 10px;\n      }\n\n      p {\n        &:hover {\n          color: var(--blue);\n          text-decoration: underline;\n        }\n      }\n    }\n\n    .unit {\n      @include default-box;\n\n      &__body {\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n      }\n\n      &--title {\n        font-size: 16px;\n        line-height: 24px;\n        font-weight: 600;\n      }\n\n      &__content {\n        display: flex;\n        gap: 10px;\n\n        &--info {\n          display: flex;\n          flex-direction: column;\n          gap: 10px;\n          width: 100%;\n\n          &--item {\n            padding-bottom: 5px;\n\n            &:not(:last-child) {\n              border-bottom: 1px solid var(--light-grey);\n            }\n\n            &--name {\n              font-size: 14px;\n              font-weight: 600;\n            }\n\n            &--sub-name {\n              font-size: 14px;\n              margin-bottom: 5px !important;\n            }\n\n            .link {\n              &:hover,\n              &:hover > * {\n                color: var(--blue) !important;\n                text-decoration: underline;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .basic-informations {\n      width: 100%;\n      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n      border-radius: 10px;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      padding: 20px;\n\n      p {\n        line-height: 20px !important;\n      }\n\n      .loading-text {\n        margin-bottom: 5px;\n      }\n\n      .work-history {\n        width: 100%;\n\n        .work-info {\n          margin: 10px 0 15px 0;\n        }\n\n        .other-profiles {\n          margin: 10px 0 15px 0;\n\n          .title-section {\n            font-weight: bold;\n            margin-bottom: 20px !important;\n          }\n\n          .profiles {\n            display: flex;\n            flex-direction: column;\n          }\n        }\n\n        .line-profile {\n          display: flex;\n          align-items: flex-start;\n          font-size: 12px;\n\n          &:not(:last-child) {\n            border-bottom: 1px solid var(--light-grey);\n          }\n\n          :global(.ant-skeleton) {\n            width: 120px;\n            height: 30px;\n            margin-bottom: 5px;\n\n            :global(.ant-skeleton-input) {\n              width: 100%;\n              height: 30px;\n            }\n          }\n\n          img {\n            width: 25px;\n            height: 25px;\n            margin-right: 10px;\n          }\n\n          svg {\n            width: 25px;\n            height: 25px;\n            margin-right: 10px;\n          }\n        }\n\n        .description {\n          p {\n            display: -webkit-box;\n            -webkit-line-clamp: 6;\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n          }\n        }\n\n        .see-more {\n          color: var(--blue);\n          text-decoration: underline;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n\n  .basic-information-mobile {\n    display: none;\n  }\n\n  @media only screen and (min-width: 901px) and (max-width: 1024px) {\n    width: 27%;\n  }\n\n  @media only screen and (max-width: 900px) {\n    width: 97%;\n    flex-direction: row;\n\n    .basic-information-landscape {\n      display: none;\n    }\n\n    .basic-information-mobile {\n      width: 100%;\n      display: flex !important;\n      flex-direction: column;\n\n      .informations {\n        overflow-x: hidden;\n        width: 100%;\n        background-color: var(--explore-color);\n        border-radius: 10px;\n        padding: 20px 10px;\n        display: flex;\n        align-items: flex-start;\n        justify-content: space-between;\n        margin-bottom: 5px;\n\n        :global(.ant-skeleton) {\n          width: 55vw;\n          margin-bottom: 5px;\n          height: 20px;\n\n          :global(.ant-skeleton-input) {\n            width: 100%;\n            height: 20px;\n          }\n        }\n\n        &__left {\n          width: 33%;\n          .avatar {\n            flex-shrink: 0;\n            :global(.ant-skeleton) {\n              width: 100px;\n              height: 100px;\n\n              :global(.ant-skeleton-avatar) {\n                width: 100px;\n                height: 100px;\n              }\n            }\n\n            margin-right: 15px;\n\n            img {\n              width: 100px;\n              height: 100px;\n              object-fit: cover;\n              border-radius: 50%;\n            }\n          }\n\n          .external-links {\n            width: 100px;\n            display: flex;\n            justify-content: center;\n          }\n        }\n\n        &__right {\n          width: 65%;\n\n          .name {\n            font-size: 20px;\n            font-weight: 600;\n            color: white;\n            margin: 0 0 5px 0 !important;\n            line-height: 1.2;\n          }\n\n          .primary-department {\n            color: white;\n\n            font-size: 14px;\n            font-weight: 600;\n          }\n\n          .position {\n            color: white;\n            font-size: 14px;\n          }\n        }\n\n        .second-section {\n          display: flex;\n          align-items: center;\n          width: 280px;\n          justify-content: space-around;\n\n          .read-bio {\n            border: 1px solid var(--explore-color);\n            border-radius: 10px;\n            height: 30px;\n            width: 90px;\n            background: transparent;\n            color: var(--explore-color);\n          }\n\n          .read-bio:hover {\n            background: var(--explore-color);\n            color: white;\n          }\n        }\n\n        .third-section {\n          margin-top: 20px;\n\n          .citation-title {\n            font-weight: 600;\n          }\n\n          :global(.ant-skeleton) {\n            width: 100%;\n            height: 200px;\n            margin-top: 10px;\n\n            :global(.ant-skeleton-input) {\n              width: 100%;\n              height: 200px;\n            }\n          }\n        }\n      }\n\n      .mobile-collaboration-btn {\n        margin-top: 10px;\n        margin-bottom: 5px;\n        width: 100%;\n        justify-content: center;\n      }\n\n      .bio-info {\n        font-size: 12px;\n        margin-top: 16px;\n        padding: 16px 24px 16px 16px;\n        gap: 8px;\n        justify-content: initial;\n        text-transform: initial;\n        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n        border-radius: 10px;\n        text-align: initial;\n        line-height: normal;\n        font-weight: 400;\n        color: var(--explore-color);\n\n        svg {\n          fill: currentColor;\n          width: 14px;\n          height: 14px;\n        }\n      }\n\n      .achievements {\n        display: flex;\n        margin-top: 10px;\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 900px) {\n  .basic-information {\n    :global(.ant-drawer-body) {\n      p {\n        line-height: 24px !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"basic-information": `BasicInformation_basic-information__4BWPZ`,
	"basic-information-landscape": `BasicInformation_basic-information-landscape__tWdk9`,
	"personal-information": `BasicInformation_personal-information__GgqO8`,
	"personal-information-main": `BasicInformation_personal-information-main__mwn8R`,
	"faculty-collaboration-btn": `BasicInformation_faculty-collaboration-btn__S6dh3`,
	"avatar": `BasicInformation_avatar__kVAo6`,
	"personal-information-text": `BasicInformation_personal-information-text__iqqrJ`,
	"name": `BasicInformation_name__59D9k`,
	"loading-text": `BasicInformation_loading-text__UmCT+`,
	"institution": `BasicInformation_institution__Fb6kj`,
	"unit": `BasicInformation_unit__WNkQd`,
	"unit__body": `BasicInformation_unit__body__w1iEc`,
	"unit--title": `BasicInformation_unit--title__CkBfz`,
	"unit__content": `BasicInformation_unit__content__eTDSA`,
	"unit__content--info": `BasicInformation_unit__content--info__p4vTk`,
	"unit__content--info--item": `BasicInformation_unit__content--info--item__kciKL`,
	"unit__content--info--item--name": `BasicInformation_unit__content--info--item--name__SFLxV`,
	"unit__content--info--item--sub-name": `BasicInformation_unit__content--info--item--sub-name__Ab1zz`,
	"link": `BasicInformation_link__nUX7X`,
	"basic-informations": `BasicInformation_basic-informations__hKl-u`,
	"work-history": `BasicInformation_work-history__A9TiR`,
	"work-info": `BasicInformation_work-info__dh2n-`,
	"other-profiles": `BasicInformation_other-profiles__BRq1Y`,
	"title-section": `BasicInformation_title-section__ITqFL`,
	"profiles": `BasicInformation_profiles__-27OP`,
	"line-profile": `BasicInformation_line-profile__BifXF`,
	"description": `BasicInformation_description__F+xF2`,
	"see-more": `BasicInformation_see-more__WRyat`,
	"basic-information-mobile": `BasicInformation_basic-information-mobile__ML6OY`,
	"informations": `BasicInformation_informations__rKyyo`,
	"informations__left": `BasicInformation_informations__left__NeAxX`,
	"external-links": `BasicInformation_external-links__s4Fq+`,
	"informations__right": `BasicInformation_informations__right__Mc-U0`,
	"primary-department": `BasicInformation_primary-department__mpRGc`,
	"position": `BasicInformation_position__2GTNQ`,
	"second-section": `BasicInformation_second-section__xuuBG`,
	"read-bio": `BasicInformation_read-bio__I-ARw`,
	"third-section": `BasicInformation_third-section__OFl6Q`,
	"citation-title": `BasicInformation_citation-title__x6qDb`,
	"mobile-collaboration-btn": `BasicInformation_mobile-collaboration-btn__VNIYg`,
	"bio-info": `BasicInformation_bio-info__2lCqY`,
	"achievements": `BasicInformation_achievements__0gNFm`
};
export default ___CSS_LOADER_EXPORT___;
